import { Model } from '@vuex-orm/core'
import User from '@/store/models/User'

export default class ProjectAttachment extends Model {
  static entity = 'projectAttachments'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      projectId: this.attr(null),
      userId: this.attr(null),
      attachmentFile: this.attr(null),
      attachmentFileName: this.string(''),
      attachmentFileSize: this.string(''),
      updatedAt: this.string('')
    }
  }

  static permitAttributes = [
    'attachmentFile',
    'attachmentFileName'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }

  getUser() {
    return User.find(this.userId)
  }
}
